import { render, staticRenderFns } from "./TradeFlexSearchListing.vue?vue&type=template&id=1fad46ac&scoped=true&"
import script from "./TradeFlexSearchListing.vue?vue&type=script&lang=js&"
export * from "./TradeFlexSearchListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fad46ac",
  null
  
)

export default component.exports